import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";

const useStyles = makeStyles(theme => ({
  whatsapp: {
    position: "fixed",
    right: theme.spacing(4),
    bottom: theme.spacing(4),
    fontSize: "30px",
    color: theme.palette.common.white,
    backgroundColor: "#1ebea5",
    zIndex: 3,

    "&:hover": {
      backgroundColor: "#50e2cb"
    }
  },
  bubble: {
    width: "210px",
    padding: theme.spacing(1.5),
    position: "fixed",
    right: theme.spacing(4),
    bottom: theme.spacing(12),
    color: theme.palette.text.primary,
    background: theme.palette.background.default,
    border: "1px solid",
    borderRadius: "5px",
    borderColor: theme.palette.divider,
    boxShadow: theme.shadows[4],
    zIndex: 4
  },
  close: {
    width: "25px",
    height: "25px",
    position: "absolute",
    top: "-12px",
    right: "-12px",
    fontSize: "1rem",
    color: theme.palette.text.primary,
    background: theme.palette.background.paper,
    border: "1px solid",
    borderColor: theme.palette.divider,
    borderRadius: "30px",
    boxShadow: theme.shadows[2]
  }
}));

const Whatsapp = ({ store }) => {
  const classes = useStyles();
  const [showBubble, setShowBubble] = useState(true);

  const sendWhatsapp = message => {
    const url = "https://wa.me/" + store.body.config.whatsapp + "?text=" + message;
    window.open(url, "_blank");
  };

  return (
    store.body.config &&
    store.body.config.whatsapp && (
      <>
        {showBubble && (
          <div className={classes.bubble}>
            <button className={classes.close} onClick={() => setShowBubble(false)}>
              <i className="fa fa-times"></i>
            </button>
            ¿Necesitas ayuda? envíame un mensaje por WhatsApp!
          </div>
        )}
        <Fab className={classes.whatsapp} onClick={() => sendWhatsapp(store.name)}>
          <WhatsAppIcon />
        </Fab>
      </>
    )
  );
};

export default Whatsapp;
